module.exports = __webpack_public_path__ + "static/img/21.91a74fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/21.png
// module id = q1Nr
// module chunks = 0